import { request,request5,request66 } from "@/utils/request";

//  从试卷中添加考生-试卷列表
export const CustomClassList = data => {
  return request({
    method: "POST",
    url: "/api/customTest/ChapterManager/CustomClassList",
    data
  });
};
// 校验APP是否存在
export const CheckAppExists = data => {
  return request({
    method: "POST",
    url: "/api/customTest/ChapterManager/CheckAppExists",
    data
  });
};
// 试题管理 - 章节三
export const ChapterThree = data => {
  return request({
    method: "POST",
    url: "/api/customTest/ChapterManager/ChapterThree",
    data
  });
};
// 添加题库
export const ChapterManager = data => {
  return request({
    method: "POST",
    url: "/api/customTest/ChapterManager/Add",
    data
  });
};
// 删除
export const Delete = data => {
  return request({
    method: "POST",
    url: "/api/customTest/ChapterManager/Delete",
    data
  });
};
// 批量删除
export const DeleteBatch = data => {
  return request({
    method: "POST",
    url: "/api/customTest/ChapterManager/DeleteBatch",
    data
  });
};
// 修改一级题库
export const Update = data => {
  return request({
    method: "POST",
    url: "/api/customTest/ChapterManager/Update",
    data
  });
};
// 试题保护
export const CryptoCustomApp = data => {
  return request({
    method: "POST",
    url: "/api/customtest/crypto/CryptoCustomApp",
    data
  });
};
//  试题保护开启
export const checkIsCrypto = data => {
  return request({
    method: "POST",
    url: "/api/customtest/crypto/checkIsCrypto",
    data
  });
};

//  上传Excel
export const ImportExcel = data => {
  return request.post("/api/customTest/ImportExcel/ImportExcel", data, {
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryzKpvSHhF9k7si60J"
    }
  });
};

//  上传Excel
export const ImportOfficial = data => {
  return request.post("/api/customTest/importOfficialTest/import", data, {
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryzKpvSHhF9k7si60J"
    }
  });
};
// 上传word
// export const importWord = data => {
//   return request66({
//     method: "POST",
//     url: "operation-service/customQuestion/importWord",
//     data
//   });
// };
// 新的word上传
export const importWord = data => {
  return request66({
    method: "POST",
    url: "/customQuestion/importWord",
    data
  });
};
//  获取全部试卷类型题目
export const getChapterAllTest = data => {
  return request({
    method: "POST",
    url: "/api/customTest/GetChapterAllTest/GetChapterAllTest",
    data
  });
};

//  新增自定义题库
export const addtest = data => {
  return request({
    method: "POST",
    url: "/api/customTest/ImportSingleTest/Add",
    data
  });
};
// 编辑自定义题库
export const UpDate = data => {
  return request({
    method: "POST",
    url: "/api/customTest/ImportSingleTest/UpDate",
    data
  });
};
// 客户试题条件查询分页列表
export const BySeekName = data => {
  return request({
    method: "POST",
    url: "/api/customTest/ChapterManager/CustomClassListBySeekName",
    data
  });
};
// 删除
export const DeleteImportSingleTest = data => {
  return request({
    method: "POST",
    url: "/api/customTest/ImportSingleTest/Delete",
    data
  });
};

//平台题库列表
export const CollectCustomClassList = data => {
  return request({
    method: "POST",
    url: "/api/customTest/ChapterManager/CollectCustomClassList",
    data
  });
};

//题库列表ID
export const ChapterTestListInfo = data => {
  return request({
    method: "POST",
    url: "/api/customTest/ImportSingleTest/ChapterTestListInfo",
    data
  });
};

//添加收藏题库
export const AddCollect = data => {
  return request({
    method: "POST",
    url: "/api/customTest/ChapterManager/AddCollect",
    data
  });
};

//填题到试卷里
export const AddCollecttest = data => {
  return request({
    method: "POST",
    url: "/api/customTest/ImportSingleTest/AddCollect",
    data
  });
};

//批量删除。
export const DeleteTestBatch = data => {
  return request({
    method: "POST",
    url: "/api/customTest/ImportSingleTest/DeleteTestBatch",
    data
  });
};